export default "__VITE_ASSET__oVmpiBSN__"